import { store } from '@/app/store';
import { deleteMessagesForEveryone, deleteMessagesForMe } from '@/infrastructure/sdk/message';
import { resetSelectedMessages } from '../model';
import { getUserIdFromJid } from '@/shared/utils';

export const handleDeleteMessages = ({ jid, msgIds, deleteForEveryOne }) => {
   const chatId = getUserIdFromJid(jid);
   if (deleteForEveryOne) {
      deleteMessagesForEveryone(jid, msgIds);
   } else {
      deleteMessagesForMe(jid, msgIds);
   }
   store.dispatch(resetSelectedMessages({ chatId }));
};
